// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"661d9dcf698337566bc8","303":"37442ce83d2dee7c183a","495":"64e5178cd809a91dc316"}[chunkId] + ".js";
};